import { render, staticRenderFns } from "./SsInsurancePage.vue?vue&type=template&id=17cb70ef"
import script from "./SsInsurancePage.vue?vue&type=script&lang=ts"
export * from "./SsInsurancePage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports